import { createFileRoute } from "@tanstack/react-router";
import { FichaCliente } from "@/features/clientes/FichaCliente";

export const Route = createFileRoute("/_authenticated/app/clientes/$id")({
  component: PaginaCliente,
});

function PaginaCliente() {
  const { id } = Route.useParams();
  return <FichaCliente key={id} clientId={id} />;
}
